import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Chave Consórcios',
    description: 'Consórcio de imóveis, automóveis, motos, pesados e serviços, sem juros e sem entrada. Simule sua parcela na hora e receba uma proposta sob medida.',
    url: getOrigin(),
    locale: 'pt_BR',
    ogImage: 'https://chave-consorcios.cdn.modulify.website/compartilhamento/chave-consorcios.jpg'
}
